import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {
  constructor(private http: HttpClient) { }

  recordBudgetAssignment(orderId: number, budgetId: number, amount: number): Observable<any> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const transaction = {
      ItemID: null,
      WarehouseID: null,
      TransactionType: 'Budget Assignment',
      QuantityChange: 0,
      CostPerUnit: amount,
      TransactionDate: new Date().toISOString(),
      ReferenceType: 'ProductionOrder',
      ReferenceID: orderId.toString(),
      UserID: 1,
      Notes: `Budget ID: ${budgetId}`,
      BatchNumber: null,
      ExpiryDate: null,
      ReferenceTypeCode: 'BUDGET_ASSIGN'
    };

    return this.http.post(
      `${environment.apiUrl}/api/InventoryTransactions`,
      transaction,
      { headers }
    );
  }

  getBudgetAssignments(orderId: number): Observable<any> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.get<any[]>(`${environment.apiUrl}/api/InventoryTransactions`, {
      headers,
      params: {
        ReferenceTypeCode: 'BUDGET_ASSIGN',
        ReferenceID: orderId.toString()
      }
    });
  }
}
